import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type DefaultShiftWithParamsForm from 'modules/shift_management/lib/forms/DefaultShiftWithParamsForm'
import { useGetPlannedBreaks } from 'modules/time_planning/hooks/plannedBreaks/useGetPlannedBreaks'

import SavedShiftItem from './SavedShiftItem'

type Form = DefaultShiftWithParamsForm

interface Props {
  label?: string
  forms: Form[]
  onToggleShift: (id: string) => void
}

const List = ({ label, forms, onToggleShift }: Props) => {
  const defaultShiftIds = forms.map((form) => +form.get('id').value)
  const { plannedBreaksCollection } = useGetPlannedBreaks({
    variables: { defaultShiftIds },
    skip: !defaultShiftIds.length,
  })

  return (
    <Box gap="s8">
      {label && (
        <Text.Normal size="100" weight="medium">
          {label}
        </Text.Normal>
      )}
      <Box gap="s8">
        {forms.map((form) => (
          <SavedShiftItem
            key={form.get('id').value}
            form={form}
            plannedBreaks={plannedBreaksCollection.filterByDefaultShift(form.get('id').value)}
            onToggleShift={onToggleShift}
          />
        ))}
      </Box>
    </Box>
  )
}

export default observer(List)
